import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { Arbitrator, AttributeModiferKeys } from './Arbitrator';
export const PresentAttribute = (props) => {
    const { name, attribute, rangeLimits, disable, isRoot } = props;
    const [checked, setChecked] = useState(false);
    const disabled = isRoot ? !checked : disable;
    useEffect(() => {
        if (disabled)
            setChecked(false);
    }, [disabled]);
    const more = [];
    const payload = {};
    let valid = !disabled;
    const { attributeType, ...others } = rangeLimits;
    for (const [key, other] of Object.entries(others)) {
        if (!AttributeModiferKeys.includes(key)) {
            const { elements, payload: p, valid: v, } = Arbitrator({
                name: key,
                attribute,
                rangeLimits: other,
                disable: isRoot ? !checked : disable,
                isRoot: false,
            });
            more.push(elements);
            payload[name] ??= {};
            if (p[key] !== undefined)
                payload[name][key] = p[key];
            valid = valid && v;
        }
    }
    if (!disabled)
        payload[name] ??= true;
    const present = isRoot ? _jsx(Checkbox, { checked: checked, onChange: (e) => setChecked(e.target.checked), disabled: disable }) : _jsx(_Fragment, {});
    const elements = more.length ? (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 1, children: [present, _jsxs(Stack, { gap: 1, children: [...more] })] })) : (present);
    return { elements, payload, valid };
};
